import Service from '@ember/service';
import Analytics, { LOADING, ACTIVE, ABANDONED } from '../utils/analytics.ts';
import type { Logger } from '../utils/analytics';
export type { Logger };

export default class AnalyticsService extends Service {
  analytics: Analytics = new Analytics();

  start(
    toolname: string,
    url: string,
    isSSR: boolean,
    isTesting: boolean,
    logSuppressions: boolean,
    logger?: Logger,
  ): void {
    this.analytics.start(toolname, url, isSSR, isTesting, logSuppressions, logger);
  }
  willDestroy(): void {
    this.analytics.stop();
  }
  setWebEvent(toolName: string, eventName: string, eventData?: string): void {
    this.analytics.setWebEvent(toolName, eventName, eventData);
  }
  get isActive(): boolean {
    return this.analytics.state === ACTIVE;
  }
  get isAbandoned(): boolean {
    return this.analytics.state === ABANDONED;
  }
  get isLoading(): boolean {
    return this.analytics.state === LOADING;
  }
}
declare module '@ember/service' {
  interface Registry {
    'aditools-analytics': AnalyticsService;
  }
}
